var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-arrow",on:{"click":function($event){return _vm.clicked()}}},[_c('svg',{staticClass:"toggle-arrow__svg",attrs:{"id":'toggler_' + this._uid,"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 60 40"}},[_c('polygon',{staticClass:"arrow svg-fill--gray-darkest",attrs:{"points":"30 0 60 40 0 40"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-630cc030","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/navigation/shared/ToggleArrow.vue
// module id = 246
// module chunks = 0